<template>
  <div :class="fullWidth ? 'container-fluid' : 'container'" :style="{ color: textColor }">
    <div class="mb-2">
      <prismic-rich-text
        :field="title"
        class="page-title d-flex w-100 mb-3"
        :class="textClasses"
        :style="{ color: headerColor }"
      ></prismic-rich-text>
      <prismic-rich-text
        :field="subtitle"
        class="page-subtitle d-flex w-100"
        :class="textClasses"
        :style="{ color: headerColor }"
      ></prismic-rich-text>
    </div>
    <div class="row">
      <div
        v-if="imageUrl"
        class="col-12 col-md-5 col-xl2-6"
        :class="alignImage == 'Right' && 'order-1'"
      >
        <img :src="imageUrl" :alt="imageAlt" class="img-fluid" />
      </div>
      <div class="col-12 align-self-center m-auto" :class="{ 'col-md-7 col-xl2-6': imageUrl }">
        <div class="row">
          <div v-for="(item, index) in items" :key="index" class="col-12 col-lg-6">
            <div class="media">
              <div class="media-aside align-self-start">
                <img
                  :src="item.image_item.url"
                  :alt="item.image_item.alt"
                  class="img-fluid mr-2"
                  width="30"
                  height="30"
                />
              </div>
              <div class="media-body">
                <h5 class="mt-0">{{ item.title_item[0].text }}</h5>
                <p>
                  {{ item.text_item[0].text }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      textColor: '',
      alignImage: '',
      imageUrl: '',
      imageAlt: '',
      fullWidth: false,
      items: [],
      title: '',
      subtitle: '',
      alignText: '',
      headerColor: '#000'
    };
  },
  computed: {
    textClasses() {
      return this.alignText === 'left'
        ? 'justify-content-start'
        : this.alignText === 'right'
        ? 'justify-content-end'
        : 'justify-content-center';
    }
  },
  created() {
    const { primary, items } = this.slice;
    this.textColor = primary.text_color;
    this.alignImage = primary.align_image;
    this.imageUrl = primary.image.url;
    this.imageAlt = primary.image.alt;
    this.fullWidth = primary.full_width;
    this.items = items;

    this.title = primary.title1;
    this.subtitle = primary.subtitle;
    this.alignText = primary.align_text ? primary.align_text : 'center';
    this.headerColor = this.slice?.primary?.header_color;
  }
};
</script>

<style></style>
